import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { OtherEntryComponent } from "@products/other-details/other-entry/other-entry.component";
import { FundMangersComponent } from "@products/other-details/fund-mangers/fund-managers.component";
import { FundNavComponent } from "@products/other-details/fund-nav/fund-nav.component";
import { IDCWHistoryComponent } from "@products/other-details/idcw-history/idcw-history.component";
import { FundRisksComponent } from "@products/other-details/fund-risks/fund-risks.component";
import { FundDocumentsComponent } from "@products/other-details/fund-documents/fund-documents.component";
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SharedModule,
    SlickCarouselModule
  ],
  declarations: [
    OtherEntryComponent,
    FundMangersComponent,
    FundNavComponent,
    IDCWHistoryComponent,    
    FundRisksComponent,
    FundDocumentsComponent
  ],
  entryComponents: [
    OtherEntryComponent
  ],
})
export class OtherFundDetailsModule {
}

export const otherFundDetailsModuleComponentMapping = {
  'IND Other Fund Content': OtherEntryComponent,
};
